import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

const AppPrivacyPolicy: React.FC = () => {
  return (
    <div style={{ width: '100%', maxHeight: '90vh', overflowY: 'auto', padding: '20px 0' }}>
    <Card style={{ maxWidth: 900, margin: '0 auto', padding: '20px' }}>
      <Typography>
        <Title level={2} style={{ textAlign: 'center' }}>Política de Privacidad</Title>
        <Paragraph>
          <Text strong>Última actualización:</Text> Abril 2026
        </Paragraph>
        <Paragraph>
          <Text strong>Samat Barinas</Text> (en adelante, "la Aplicación") es una aplicación móvil desarrollada y operada
          por <Text strong>Waku Software LLC</Text> (en adelante, "nosotros", "nuestro" o "la Empresa"). Esta política
          de privacidad describe cómo recopilamos, usamos, almacenamos y protegemos la información de los usuarios
          de nuestra aplicación con identificador <Text code>com.wakusoftware.barinas</Text>.
        </Paragraph>

        <Title level={3}>1. Información que Recopilamos</Title>
        <Paragraph>
          Podemos recopilar los siguientes tipos de información:
        </Paragraph>
        <Paragraph>
          <Text strong>1.1 Información proporcionada por el usuario:</Text>
          <ul>
            <li>Nombre completo</li>
            <li>Documento de identidad (cédula o RIF)</li>
            <li>Dirección de correo electrónico</li>
            <li>Número de teléfono</li>
            <li>Dirección fiscal o domicilio</li>
            <li>Información tributaria y comercial necesaria para los trámites municipales</li>
          </ul>
        </Paragraph>
        <Paragraph>
          <Text strong>1.2 Información recopilada automáticamente:</Text>
          <ul>
            <li>Información del dispositivo (modelo, sistema operativo, identificadores únicos)</li>
            <li>Datos de uso de la aplicación</li>
            <li>Dirección IP</li>
            <li>Registros de acceso y actividad</li>
          </ul>
        </Paragraph>

        <Title level={3}>2. Uso de la Información</Title>
        <Paragraph>
          Utilizamos la información recopilada para:
          <ul>
            <li>Procesar solicitudes y trámites tributarios municipales</li>
            <li>Gestionar la cuenta del usuario y autenticación</li>
            <li>Enviar notificaciones relacionadas con los servicios</li>
            <li>Mejorar nuestros servicios y la experiencia del usuario</li>
            <li>Cumplir con obligaciones legales y regulatorias</li>
            <li>Prevenir fraudes y actividades no autorizadas</li>
            <li>Proporcionar soporte al cliente</li>
          </ul>
        </Paragraph>

        <Title level={3}>3. Compartir Información</Title>
        <Paragraph>
          No vendemos, alquilamos ni compartimos su información personal con terceros para fines comerciales.
          Sin embargo, podemos compartir información en los siguientes casos:
          <ul>
            <li>Con entidades gubernamentales municipales para el procesamiento de trámites tributarios</li>
            <li>Con proveedores de servicios que nos ayudan a operar la aplicación (bajo acuerdos de confidencialidad)</li>
            <li>Cuando sea requerido por ley o autoridades competentes</li>
            <li>Para proteger nuestros derechos legales o la seguridad de los usuarios</li>
          </ul>
        </Paragraph>

        <Title level={3}>4. Almacenamiento y Seguridad</Title>
        <Paragraph>
          Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal,
          incluyendo:
          <ul>
            <li>Encriptación de datos en tránsito y en reposo</li>
            <li>Control de acceso basado en roles</li>
            <li>Monitoreo continuo de seguridad</li>
            <li>Servidores seguros con protección contra accesos no autorizados</li>
          </ul>
        </Paragraph>
        <Paragraph>
          Los datos se almacenan en servidores seguros y se retienen durante el tiempo necesario para cumplir
          con los fines para los que fueron recopilados y las obligaciones legales aplicables.
        </Paragraph>

        <Title level={3}>5. Derechos del Usuario</Title>
        <Paragraph>
          Usted tiene derecho a:
          <ul>
            <li><Text strong>Acceder</Text> a su información personal</li>
            <li><Text strong>Rectificar</Text> datos inexactos o incompletos</li>
            <li><Text strong>Eliminar</Text> su cuenta y datos personales (sujeto a obligaciones legales de retención)</li>
            <li><Text strong>Oponerse</Text> al procesamiento de sus datos en ciertos casos</li>
            <li><Text strong>Portabilidad</Text> de sus datos en formato estructurado</li>
          </ul>
        </Paragraph>
        <Paragraph>
          Para ejercer estos derechos, puede contactarnos a través de los canales indicados al final de esta política.
        </Paragraph>

        <Title level={3}>6. Cookies y Tecnologías Similares</Title>
        <Paragraph>
          La aplicación puede utilizar tecnologías de almacenamiento local para mejorar la experiencia del usuario,
          recordar preferencias y mantener sesiones activas. Estas tecnologías son esenciales para el funcionamiento
          de la aplicación.
        </Paragraph>

        <Title level={3}>7. Servicios de Terceros</Title>
        <Paragraph>
          La aplicación puede integrar servicios de terceros para funcionalidades específicas (procesamiento de pagos,
          análisis, etc.). Estos servicios tienen sus propias políticas de privacidad que recomendamos revisar.
        </Paragraph>

        <Title level={3}>8. Menores de Edad</Title>
        <Paragraph>
          Esta aplicación no está dirigida a menores de 18 años. No recopilamos intencionalmente información de
          menores de edad. Si descubrimos que hemos recopilado información de un menor, tomaremos medidas para
          eliminarla de nuestros sistemas.
        </Paragraph>

        <Title level={3}>9. Cambios en la Política de Privacidad</Title>
        <Paragraph>
          Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Las modificaciones
          serán efectivas desde su publicación en la aplicación. Le notificaremos sobre cambios significativos a través
          de la aplicación o por correo electrónico.
        </Paragraph>

        <Title level={3}>10. Contacto</Title>
        <Paragraph>
          Si tiene preguntas, inquietudes o solicitudes relacionadas con esta política de privacidad o el tratamiento
          de sus datos personales, puede contactarnos a través de:
        </Paragraph>
        <Paragraph>
          <Text strong>Waku Software LLC</Text><br />
          Correo electrónico: <Text copyable>soporte@wakusoftware.com</Text><br />
        </Paragraph>

        <Title level={3}>11. Consentimiento</Title>
        <Paragraph>
          Al utilizar la aplicación Samat Barinas, usted acepta los términos de esta política de privacidad y
          consiente el tratamiento de su información personal conforme a lo aquí descrito.
        </Paragraph>

        <Paragraph style={{ marginTop: 40, textAlign: 'center', color: '#666' }}>
          © {new Date().getFullYear()} Waku Software LLC. Todos los derechos reservados.
        </Paragraph>
      </Typography>
    </Card>
    </div>
  );
};

export default AppPrivacyPolicy;
